export const NIBRAS_HOOK = {
  ON_ATTRIBUTE_VALUE_CHANGED: 'on_attribute_value_changed',
  ON_DESIGNER_SETTINGS_CHANGED: 'on_designer_settings_changed',
  ON_ATTRIBUTE_INITIATES: 'on_attribute_initiated',
  ON_GENERIC_ATTRIBUTES_LOADED: 'on_generic_attributes_loaded',
  ON_WIDGET_DATE_CHANGED: 'on_widget_date_changed',
  ON_DISPLAY_TEXT_COMPONENT_LOADED: 'on_display_text_component_loaded',
  ON_DROPDOWN_INITIATES: 'on_dropdown_initiated',
  ON_ASYC_DATA_CHART_KEYS_RECIEVED: 'on_async_data_chart_keys_recieved'
};

export const NIBRAS_FILTER = {
  SUGGESTED_VALUE_PARAMS: 'suggested_value_params',
  SUGGESTED_VALUE_DISPLAY_TEXT: 'suggested_value_display_text',
  DROPDOWN_VALUE_TYPE: 'dropdown_value_types',
  SEARCH_TAG_ELEMENT_TYPES: 'search_tag_element_types',
  FORM_ATTRIBUTE_VALIDATION: 'form_attribute_validation',
  FORM_TAG_VALIDATION: 'form_tag_validation',
  FORM_DESIGNER_SETTINGS_LOADED: 'form_designer_settings_loaded',
  MULTI_SELECT_DROPDOWN_VALUE_TYPE: 'multi_select_dropdown_value_types',
  DX_TS_VIEWER_ATTRIBUTE_LOADED: 'dx_ts_viewer_attribute_loaded'
};
